import { fn } from 'storybook/test';

import type { Meta, StoryFn } from '@storybook/react';
import type { RadioTabSelectorProps } from './RadioTabSelector'; // Already imported above

import { RadioTabSelector } from './RadioTabSelector';

const codeString =
  '<RadioTabSelector radioButtons={} defaultValue={} label={} labelPosition={} required={} notValidatedText={} onSetValue={} />';

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Molecules/RadioTabSelector',
  component: RadioTabSelector,
  argTypes: {
    radioButtons: {
      table: {
        disable: true,
      },
    },
    defaultValue: {
      table: {
        disable: true,
      },
    },
    label: {
      control: 'text',
    },
    labelPosition: {
      control: 'radio',
      options: ['top', 'left'],
    },
    required: {
      control: 'boolean',
    },
    notValidatedText: {
      control: 'text',
    },
    onSetValue: {
      table: {
        disable: true,
      },
    },
  },
  parameters: {
    inspectComponent: RadioTabSelector,
    codeString: codeString,
  },
} as Meta<RadioTabSelectorProps>;

const Template: StoryFn<RadioTabSelectorProps> = (args) => <RadioTabSelector {...args} />;

export const RadioTabSelectorExample = Template.bind({});
RadioTabSelectorExample.args = {
  buttons: [
    { label: 'Digitaal', value: 'digitaal' },
    { label: 'Schriftelijk', value: 'schriftelijk' },
    { label: 'Presentatie', value: 'presentatie' },
  ],
  defaultValue: 'digitaal',
  radioGroupName: 'radio-group',
  label: 'Toetsvorm',
  labelPosition: 'top',
  required: true,
  notValidatedText: '',
  onSetValue: fn(),
};

export const WithIcons = Template.bind({});
WithIcons.args = {
  buttons: [
    { label: 'Digitaal', value: 'digitaal', iconName: 'SignalActive' },
    { label: 'Schriftelijk', value: 'schriftelijk', iconName: 'Pencil' },
    { label: 'Presentatie', value: 'presentatie', iconName: 'User' },
  ],
  defaultValue: 'digitaal',
  radioGroupName: 'radio-group',
  label: 'Toetsvorm',
  labelPosition: 'top',
  required: true,
  notValidatedText: '',
  onSetValue: fn(),
};
